export enum ColumnNames {
  Id = 'Id',
  CreateDate = 'CreateDate',
  Name = 'Name',
  Email = 'Email',
  Permission = 'Permission',
}

export interface CreateUserRequest {
  clientId: number;
  name: string;
  userName: string;
  email: string;
  password: string;
  isActive: boolean;
  userPhoto: string | null;
  firstPage?: string;
  isExemptedFromSync: boolean;
  permissions: string[];
}

export interface PutUserRequest {
  id: number;
  clientId: number;
  name: string;
  userName: string;
  email: string;
  isActive: boolean;
  userPhoto: string | null;
  firstPage?: string;
  isExemptedFromSync: boolean;
  permissions: string[];
}

export interface GetUserResponse {
  id: number;
  clientId: number;
  createDate?: Date;
  name: string;
  userName: string;
  email: string;
  isActive: boolean;
  lastLoggedIn?: Date;
  userPhoto?: string;
  firstPage?: string;
  ssoUsername?: string;
  isExemptedFromSync: boolean;
  permissions?: string;
  permissionIds?: string;
}

export type UserPageState = 'DataTable' | 'NoUserPage' | 'AddUserPage' | 'UpdateUserPage';
